import { DsSummaryDashboardDataInterface } from '../interfaces/ds-summary-dashboard-data.interface';

/**
 * Object retrieved from the backend. Represents for instance a status, its id, and the number of occurences.
 */
export class DsSummaryDashboardData {
  /**
   * The id.
   */
  id: number;

  /**
   * The name. (it is given by the backend to avoid mistakes).
   */
  name: string;

  /**
   * The number of occurrences of the dashboard.
   */
  count?: number;

  /**
   * The dashboard status.
   */
  status?: DsSummaryDashboardDataInterface[] = [];

  /**
   * Creates an instance of DsSummaryDashboardData.
   *
   * @param jsonData Json data
   */
  constructor(jsonData: DsSummaryDashboardDataInterface) {
    this.id = jsonData.id;
    this.name = jsonData.name;
    this.count = jsonData.count;
    this.status = jsonData.status;
  }
}
